export default __webpack_public_path__ + "static/Extendible-88d415d492ab62a3cc763ec674368df8.png";